var _style, _switch;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgConsolidateSuper = function SvgConsolidateSuper(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "consolidate-super_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 80 80",
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".consolidate-super_svg__st1{fill:#eaeaea}")), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "consolidate-super_svg__SVGID_1_",
    d: "M0 0h80v80H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "consolidate-super_svg__SVGID_00000069374963374211811230000015342766305514929287_"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#consolidate-super_svg__SVGID_1_"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#consolidate-super_svg__SVGID_00000069374963374211811230000015342766305514929287_)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 80c22.093 0 40-17.909 40-40C80 17.907 62.093-.001 40-.001 17.908-.001 0 17.907 0 40c0 22.092 17.908 40 40 40",
    className: "consolidate-super_svg__st1"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#consolidate-super_svg__SVGID_00000069374963374211811230000015342766305514929287_)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 80c22.093 0 40-17.909 40-40C80 17.907 62.093-.001 40-.001 17.908-.001 0 17.907 0 40c0 22.092 17.908 40 40 40",
    className: "consolidate-super_svg__st1"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#consolidate-super_svg__SVGID_00000069374963374211811230000015342766305514929287_)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M70.208 47.746l-.628-16.658a3.62 3.62 0 00-3.742-3.469l-16.657.627a3.62 3.62 0 00-3.469 3.743l.25 6.644 1.37-.052a4.29 4.29 0 013.847-2.752 4.288 4.288 0 014.448 4.125 4.292 4.292 0 01-8.169 1.996l-1.369.05.251 6.644a3.615 3.615 0 003.739 3.469l16.658-.627a3.619 3.619 0 003.471-3.74"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#consolidate-super_svg__SVGID_00000069374963374211811230000015342766305514929287_)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ed4300",
    d: "M41.02 36.17a4.202 4.202 0 00-4.435 1.333l-.731-.219 1.81-6.025a3.619 3.619 0 00-2.417-4.492L19.28 21.974a3.617 3.617 0 00-4.492 2.417L9.996 40.355a3.616 3.616 0 002.417 4.493l15.964 4.793a3.62 3.62 0 004.493-2.417l2.035-6.781.73.221a4.203 4.203 0 105.385-4.494"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgConsolidateSuper);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/consolidate-super.4a3f8b745969167582139a26112170f4.svg";